import { CONSTANTS } from "../data";
import type { QualityGrade } from "../types";

// Quality grade, temperature, and timing scoring
export const calculateQualityGrade = (score: number): QualityGrade => {
  for (const [grade, def] of Object.entries(CONSTANTS.QUALITY_GRADES)) {
    if (score >= def.threshold) {
      return {
        grade,
        name: def.name,
        color: def.color,
        multiplier: def.multiplier,
        score,
      };
    }
  }
  // Fallback
  return {
    grade: "F",
    name: "Poor",
    color: "#696969",
    multiplier: 0.75,
    score,
  };
};

export const calculateTempScore = (
  temp: number,
  optimalRange: { min: number; max: number }
): number => {
  if (temp >= optimalRange.min && temp <= optimalRange.max) {
    return CONSTANTS.QUALITY_SCORING.maxTempScore;
  }
  // Linear penalty outside optimal range
  const delta = Math.min(
    Math.abs(temp - optimalRange.min),
    Math.abs(temp - optimalRange.max)
  );
  return Math.max(
    0,
    CONSTANTS.QUALITY_SCORING.maxTempScore - delta * 2
  );
};

export const calculateTimingScore = (
  elapsedTime: number,
  window: number
): number => {
  if (elapsedTime > window) {
    return 0; // Outside the window
  }
  // Linear score within the window
  const score =
    CONSTANTS.QUALITY_SCORING.maxTimingScore * (1 - elapsedTime / window);
  return Math.max(0, score);
};
